import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../../constants/config.js";

function TroubleshootNotice() {
    const [ componentLoading , setLoading ] = useState( true );
    const [ misconfiguredCount , setMisconfiguredCount ] = useState( 0 );
    const [ reloadCount , setReloadCount ] = useState( 0 );

    useEffect( () => {
        async function loadData() {
            setLoading( true );
            let finalCount = 1;
            try {
                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/troubleshooting/issues/count`;
                const requestSettings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                const response = await fetch( url , requestSettings );
                const data = await response.json();

                if ( data?.misconfigured_count != null ) {
                    finalCount = data.misconfigured_count;
                }
                
            } catch ( error ) {
                console.log( error );
            } finally {
                setMisconfiguredCount( finalCount );
                setLoading( false );
            }
        }

        loadData();
    } , [ reloadCount ] )

    function reloadView() {
        setReloadCount( reloadCount + 1 );
    }

    if ( componentLoading ) {
        return( 
            <div className="troubleshooting-notice-skeleton"></div>
        )
    }

    if ( misconfiguredCount > 0 ) {
        return(
            <div className="ts-notice-container">
                <button onClick={reloadView} className="refresh-button">
                    <svg width="12" height="12" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1953 8.52115C12.529 11.0553 10.2321 12.9231 7.5 12.9231C5.79241 12.9231 4.25558 12.1928 3.1808 11.0284L4.55357 9.64856C4.72433 9.47692 4.82143 9.24135 4.82143 8.99904C4.82143 8.49086 4.41295 8.08029 3.90737 8.08029L0.535714 8.07692C0.241071 8.07692 0 8.31923 0 8.61538V12.0043C0 12.5125 0.408482 12.9231 0.914062 12.9231C1.15513 12.9231 1.38951 12.8255 1.56027 12.6538L2.42076 11.7889C3.69308 13.1486 5.49777 14 7.5 14C10.7612 14 13.5 11.7452 14.2567 8.70288C14.3371 8.37644 14.0826 8.07692 13.7478 8.07692C13.4866 8.07692 13.2623 8.26538 13.1953 8.52115ZM11.8192 2.97163L10.4464 4.35144C10.2757 4.52308 10.1786 4.75865 10.1786 5.00096C10.1786 5.50913 10.5871 5.91971 11.0926 5.91971L14.4643 5.92308C14.7589 5.92308 15 5.68077 15 5.38462V1.99567C15 1.4875 14.5915 1.07692 14.0859 1.07692C13.8449 1.07692 13.6105 1.17452 13.4397 1.34615L12.5792 2.21106C11.3069 0.851442 9.50223 0 7.5 0C4.23884 0 1.5 2.25481 0.743304 5.29711C0.662946 5.62356 0.917411 5.92308 1.25223 5.92308C1.51339 5.92308 1.73772 5.73462 1.80469 5.47885C2.47098 2.94471 4.76786 1.07692 7.5 1.07692C9.20759 1.07692 10.7444 1.80721 11.8225 2.97163H11.8192ZM13.9286 4.84615H11.471L13.9286 2.37596V4.84615ZM1.07143 9.15385H3.52902L1.07143 11.624V9.15385Z" fill="#1E1E2C">
                        </path>
                    </svg>
                </button>

                <div className="ts-notice-header">
                    <svg width="50" height="35" viewBox="0 0 50 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25 2.5C26.9698 2.5 28.9204 2.88799 30.7403 3.64181C32.5601 4.39563 34.2137 5.50052 35.6066 6.8934C36.9995 8.28628 38.1044 9.93986 38.8582 11.7597C39.612 13.5796 40 15.5302 40 17.5C40 19.4698 39.612 21.4204 38.8582 23.2403C38.1044 25.0601 36.9995 26.7137 35.6066 28.1066C34.2137 29.4995 32.5601 30.6044 30.7403 31.3582C28.9204 32.112 26.9698 32.5 25 32.5C23.0302 32.5 21.0796 32.112 19.2597 31.3582C17.4399 30.6044 15.7863 29.4995 14.3934 28.1066C13.0005 26.7137 11.8956 25.0601 11.1418 23.2403C10.388 21.4204 10 19.4698 10 17.5C10 15.5302 10.388 13.5796 11.1418 11.7597C11.8956 9.93986 13.0005 8.28628 14.3934 6.8934C15.7863 5.50052 17.4399 4.39563 19.2597 3.64181C21.0796 2.88799 23.0302 2.5 25 2.5ZM25 35C29.6413 35 34.0925 33.1563 37.3744 29.8744C40.6563 26.5925 42.5 22.1413 42.5 17.5C42.5 12.8587 40.6563 8.40752 37.3744 5.12563C34.0925 1.84374 29.6413 0 25 0C20.3587 0 15.9075 1.84374 12.6256 5.12563C9.34374 8.40752 7.5 12.8587 7.5 17.5C7.5 22.1413 9.34374 26.5925 12.6256 29.8744C15.9075 33.1563 20.3587 35 25 35ZM26.25 8.75C26.25 8.0625 25.6875 7.5 25 7.5C24.3125 7.5 23.75 8.0625 23.75 8.75V18.75C23.75 19.4375 24.3125 20 25 20C25.6875 20 26.25 19.4375 26.25 18.75V8.75ZM25 26.875C25.4973 26.875 25.9742 26.6775 26.3258 26.3258C26.6775 25.9742 26.875 25.4973 26.875 25C26.875 24.5027 26.6775 24.0258 26.3258 23.6742C25.9742 23.3225 25.4973 23.125 25 23.125C24.5027 23.125 24.0258 23.3225 23.6742 23.6742C23.3225 24.0258 23.125 24.5027 23.125 25C23.125 25.4973 23.3225 25.9742 23.6742 26.3258C24.0258 26.6775 24.5027 26.875 25 26.875ZM6.05469 5.35937C6.42969 4.78125 6.25781 4.00781 5.67969 3.63281C5.10156 3.25781 4.32812 3.42969 3.95312 4.00781C1.44531 7.90625 0 12.5312 0 17.5C0 22.4688 1.44531 27.0938 3.94531 30.9922C4.32031 31.5703 5.09375 31.7422 5.67187 31.3672C6.25 30.9922 6.42188 30.2187 6.04688 29.6406C3.80469 26.1406 2.5 21.9766 2.5 17.5C2.5 13.0234 3.80469 8.85937 6.05469 5.35937ZM46.0547 4.00781C45.6797 3.42969 44.9062 3.25781 44.3281 3.63281C43.75 4.00781 43.5781 4.78125 43.9531 5.35937C46.1953 8.85937 47.5 13.0234 47.5 17.5C47.5 21.9766 46.1953 26.1406 43.9453 29.6406C43.5703 30.2187 43.7422 30.9922 44.3203 31.3672C44.8984 31.7422 45.6719 31.5703 46.0469 30.9922C48.5469 27.0938 50 22.4688 50 17.5C50 12.5312 48.5469 7.90625 46.0547 4.00781Z" fill="#F5812C"/>
                    </svg>
    
                    <h2>PRODUCT MISCONFIGURED</h2>
                </div>
                <div className="ts-notice-body">
                    <p>{misconfiguredCount} Product(s) are currently misconfigured.</p>
                    <Link to="/troubleshooting">
                        CHECK STATUS
                    </Link>
                </div>
            </div>
        );
    }
    
    return null;
}

export default TroubleshootNotice;